// Template 6: Teal Card
// Clean centered card design with teal accent

import { 
  Phone, 
  MessageCircle, 
  Mail, 
  Share2, 
  Download,
  Linkedin,
  Instagram,
  Github,
  Facebook,
  Youtube,
  Twitter,
  Globe,
  QrCode
} from 'lucide-react'

export function TealCardTemplate({ vcard, onSaveContact, onShare }) {
  return (
    <div className="teal-card-template">
      <div className="tc-wrapper">
        <div className="tc-card">
          {/* Profile Header */}
          <div className="tc-profile">
            <div 
              className="tc-avatar"
              style={{ 
                backgroundImage: vcard.profileImage ? `url(${vcard.profileImage})` : 'none'
              }}
            >
              {!vcard.profileImage && (
                <span>{vcard.name?.[0] || 'U'}</span>
              )}
            </div>
            <div className="tc-info">
              <h1 className="tc-name">{vcard.name || 'Your Name'}</h1>
              <p className="tc-title">
                {vcard.title || 'Your Title'}
                {vcard.company && ` at ${vcard.company}`}
              </p>
            </div>
          </div>

          {/* Primary Actions */}
          <div className="tc-primary-actions">
            {vcard.phone && (
              <a href={`tel:${vcard.phone}`} className="tc-btn-primary">
                <Phone size={20} />
                <span>Call</span>
              </a>
            )}
            {vcard.whatsapp && (
              <a 
                href={`https://wa.me/${vcard.whatsapp.replace(/\D/g, '')}`}
                target="_blank"
                rel="noopener noreferrer"
                className="tc-btn-primary"
              >
                <MessageCircle size={20} />
                <span>WhatsApp</span>
              </a>
            )}
            {vcard.email && (
              <a href={`mailto:${vcard.email}`} className="tc-btn-primary">
                <Mail size={20} />
                <span>Email</span>
              </a>
            )}
          </div>

          {/* About */}
          {vcard.about && (
            <div className="tc-about">
              <p>{vcard.about}</p>
            </div>
          )}

          {/* Services */}
          {vcard.services && vcard.services.length > 0 && (
            <div className="tc-services">
              {vcard.services.map((service, i) => (
                <span key={i} className="tc-service-tag">{service}</span>
              ))}
            </div>
          )}

          {/* Social Links */}
          {vcard.social && Object.values(vcard.social).some(v => v) && (
            <div className="tc-social-grid">
              {vcard.social.linkedin && (
                <a 
                  href={vcard.social.linkedin.startsWith('http') ? vcard.social.linkedin : `https://linkedin.com/in/${vcard.social.linkedin}`}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="tc-social-item"
                >
                  <div className="tc-social-icon">
                    <Linkedin size={20} />
                  </div>
                  <span>LinkedIn</span>
                </a>
              )}
              {vcard.social.github && (
                <a 
                  href={vcard.social.github.startsWith('http') ? vcard.social.github : `https://github.com/${vcard.social.github}`}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="tc-social-item"
                >
                  <div className="tc-social-icon">
                    <Github size={20} />
                  </div>
                  <span>GitHub</span>
                </a>
              )}
              {vcard.social.instagram && (
                <a 
                  href={vcard.social.instagram.startsWith('http') ? vcard.social.instagram : `https://instagram.com/${vcard.social.instagram.replace('@', '')}`}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="tc-social-item"
                >
                  <div className="tc-social-icon">
                    <Instagram size={20} />
                  </div>
                  <span>Instagram</span>
                </a>
              )}
              {vcard.social.facebook && (
                <a 
                  href={vcard.social.facebook.startsWith('http') ? vcard.social.facebook : `https://facebook.com/${vcard.social.facebook}`}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="tc-social-item"
                >
                  <div className="tc-social-icon">
                    <Facebook size={20} />
                  </div>
                  <span>Facebook</span>
                </a>
              )}
              {vcard.social.twitter && (
                <a 
                  href={vcard.social.twitter.startsWith('http') ? vcard.social.twitter : `https://twitter.com/${vcard.social.twitter.replace('@', '')}`}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="tc-social-item"
                >
                  <div className="tc-social-icon">
                    <Twitter size={20} />
                  </div>
                  <span>Twitter</span>
                </a>
              )}
              {vcard.social.website && (
                <a 
                  href={vcard.social.website.startsWith('http') ? vcard.social.website : `https://${vcard.social.website}`}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="tc-social-item"
                >
                  <div className="tc-social-icon">
                    <Globe size={20} />
                  </div>
                  <span>Website</span>
                </a>
              )}
            </div>
          )}

          {/* Secondary Actions */}
          <div className="tc-secondary-actions">
            <button onClick={onSaveContact} className="tc-btn-secondary">
              <Download size={18} />
              <span>Save Contact</span>
            </button>
            <button onClick={onShare} className="tc-btn-secondary">
              <Share2 size={18} />
              <span>Share vCard</span>
            </button>
          </div>
        </div>
      </div>
      
      <footer className="tc-footer">
        <p>Powered by <a href="/">Digital vCard</a></p>
      </footer>
    </div>
  )
}

export default TealCardTemplate
